import React, { useEffect, useState } from 'react';
import { Container, Title } from './ContainerSummaryStyled';
import SummaryMeeting from '../SummaryMeeting/SummaryMeeting';
import { pdcMeetingApi } from '../../../../services/pdcMeetingApi';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { get, isEmpty } from 'lodash';
import { Spin } from 'antd';
import { PRC_MEETING_SUMMARY_TABLES_KEYS } from '../../constants';

const ContainerSummary = () => {
  const { idMeeting } = useParams();
  const roleActive = useSelector((state) => state.user.roleActive);
  const selectedKeys = useSelector((state) => state.app.pdcMeetingModule.pdcSummaryTableView.selectedKeys);
  const [data, setData] = useState({
    by_proposal_type: [],
    by_effective_date: [],
    loading: true,
  });
  const [selectedKey, setSelectedKey] = useState(selectedKeys);

  useEffect(() => {
    if (!idMeeting) {
      return;
    }

    pdcMeetingApi.getMeetingPdcSummaryTableView(idMeeting).then((res) => {
      const { data } = res;
      setSelectedKey(data.result);
    });
  }, [idMeeting, selectedKeys]);

  useEffect(() => {
    if (!idMeeting || !roleActive.roleId) return;
    (async function getSummaryProposal() {
      try {
        setData((prev) => ({ ...prev, loading: true }));
        const res = await pdcMeetingApi.fetchSummaryProposal(idMeeting, roleActive.roleId);
        setData({
          by_proposal_type: get(res, 'data.result.by_proposal_type') || [],
          by_effective_date: get(res, 'data.result.by_effective_date') || [],
          loading: false,
        });
      } catch (error) {
        console.log(error);
        setData({
          by_proposal_type: [],
          by_effective_date: [],
          loading: false,
        });
      }
    })();
  }, [idMeeting, roleActive.roleId]);

  return (
    <Spin spinning={data.loading}>
      <Container style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
        {selectedKey === PRC_MEETING_SUMMARY_TABLES_KEYS.ALL || selectedKey === PRC_MEETING_SUMMARY_TABLES_KEYS.PDC_PROPOSAL ? (
          <div>
            {!isEmpty(data.by_proposal_type) && (
              <>
                <Title>Summary of PDC Proposal</Title>
                <SummaryMeeting data={data.by_proposal_type} />
              </>
            )}
          </div>
        ) : null}

        {selectedKey === PRC_MEETING_SUMMARY_TABLES_KEYS.ALL || selectedKey === PRC_MEETING_SUMMARY_TABLES_KEYS.PDC_PROPOSAL_BY_EFFECTIVE_DATE ? (
          <div>
            {!isEmpty(data.by_effective_date) && (
              <>
                <Title>Summary of PDC Proposal By Effective Date</Title>
                <SummaryMeeting data={data.by_effective_date} isByDate />
              </>
            )}
          </div>
        ) : null}
      </Container>
    </Spin>
  );
};

export default ContainerSummary;
